import React from 'react'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { buildExtSlices } from '../../../../../utils/helpers'
import { FormularyCoveragePlanTable } from '@teschglobal/tg-fhir-react-components'
import { CombinedList, List } from '@teschglobal/tg-fhir-react-components/dist/types'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'

type FormularyCoveragePlanListProps = {
  coveragePlans: ProviderResponse<List>
  clickViewDataLink: (organization: List) => void
  isFetching: boolean
  isLoading: boolean
  isSuccess: boolean
  totalPages: number
  currentPage: number
  handleChangePage: (page: number) => void
}

const FormularyCoveragePlanList: React.FC<FormularyCoveragePlanListProps> = ({
  coveragePlans,
  clickViewDataLink,
  isFetching,
  isLoading,
  totalPages,
  currentPage,
  handleChangePage
}) => {
  const { data: environment } = useEnvironment()

  const rows: CombinedList[] =
    coveragePlans?.data?.map((resource) => {
      const extSlices = buildExtSlices(
        (resource.extension ?? []) as any,
        'FormularyCoveragePlan'
      )
      return { ...resource, ...extSlices } as CombinedList
    }) ?? []

  return (
    <>
      <h3>List (Formulary Coverage Plans)</h3>

      {(isLoading || isFetching) ? (
        <FhirLoader message='Loading...' />
      ) : (
        <>
          {coveragePlans?.total > 0 &&
            environment?.includeTotalInFHIRRequest && (
              <div className='my-3 fw-bold'>
                <span role="status" aria-live="polite">
                  {coveragePlans.total.toLocaleString()} record(s) found
                </span>

                <PaginationButtons
                  totalPages={totalPages}
                  currentPage={currentPage}
                  handleChangePage={handleChangePage}
                />
              </div>
            )}

          <FormularyCoveragePlanTable
            coveragePlans={rows}
            onRowLinkClick={clickViewDataLink}
          />

          {coveragePlans?.total > 0 &&
            environment?.includeTotalInFHIRRequest && (
              <div className='my-3 fw-bold'>
                <PaginationButtons
                  totalPages={totalPages}
                  currentPage={currentPage}
                  handleChangePage={handleChangePage}
                />
              </div>
            )}
        </>
      )}
    </>
  )
}

export default FormularyCoveragePlanList